module.exports = __webpack_public_path__ + "static/media/member-4.b477df18.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Team/assets/member-4.png
// module id = 1097
// module chunks = 0